import React from 'react';
import withIcon from '../utilities/withIcon';

const IconListChecks = () => {
  return (
    <g>
      <path d="m15.1895 12.627h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 0 0 0-1.5z" />
      <circle cx="3.0315" cy="13.3504" r="1.5143" />
      <path d="m6.92 4.4707h8.269a.75.75 0 0 0 0-1.5h-8.269a.75.75 0 1 0 0 1.5z" />
      <path d="m4.7222 1.355-2.1734 2.1733-1.208-1.2075a.75.75 0 1 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 0 0 -1.0605-1.0606z" />
      <path d="m15.1895 7.8115h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 1 0 0-1.5z" />
      <path d="m4.7222 6.1958-2.1734 2.1734-1.208-1.2076a.75.75 0 0 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 1 0 -1.0605-1.0606z" />
    </g>
  );
};

export default withIcon(IconListChecks);
